export default "__VITE_ASSET__BU4H1EIJ__ 400w, __VITE_ASSET__CQCxPuAa__ 640w, __VITE_ASSET__BMreR1_D__ 900w";